var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-echarts',{staticClass:"echart-container",attrs:{"autoresize":"","option":_vm.gaugeOption}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }